export const APP_INITIAL_STATE = {
  settings: {
    isAnimationPause: false
  }
}

export const appReducer = (state, action) => {
  switch (action.type) {
    case 'TOGGLE_ANIMATION':
      return {
        ...state,
        settings: {
          isAnimationPause: !state.settings.isAnimationPause
        }
      };
    default:
      return state;
  }
};


export default appReducer